import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import zmLogo from './images/LOGO_ZM.png';
import './AdminNavbar.css';

export default function AdminNavbar() {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  const closeNav = () => setNavOpen(false);

  useEffect(() => {
    document.body.style.overflow = navOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [navOpen]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') closeNav(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    window.location.href = '/login';
  };

  const linkClass = (path) =>
    `an-link${location.pathname === path ? ' an-link-active' : ''}`;

  return (
    <div className="an-site-top">
      {/* Header oscuro */}
      <header className="an-header">
        <div className="an-header-inner">
          <Link to="/admin" className="an-logo-btn" onClick={closeNav}>
            <img src={zmLogo} alt="Zona Microondas" />
          </Link>
          <div className="an-brand">
            <span className="an-brand-title">Zona Microondas</span>
            <span className="an-brand-sub">Panel de Administrador</span>
          </div>
        </div>
      </header>

      {/* Navbar roja */}
      <nav className="an-navbar" aria-label="Menú administrador">
        <div className="an-navbar-inner">

          {/* Hamburguesa — solo visible en móvil */}
          <button
            className={`an-mob-toggle ${navOpen ? 'is-open' : ''}`}
            onClick={() => setNavOpen(p => !p)}
            aria-label={navOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={navOpen}
          >
            <div className="an-toggle-bars">
              <span></span><span></span><span></span>
            </div>
            <span className="an-toggle-label">{navOpen ? 'CERRAR' : 'MENÚ'}</span>
          </button>

          {/* Links admin */}
          <div className={`an-cats ${navOpen ? 'is-open' : ''}`}>
            <Link to="/admin" className={linkClass('/admin')} onClick={closeNav}>
              Home
            </Link>
            <a href="/admin/news/todos" className={linkClass('/admin/news/todos')} onClick={closeNav}>
              Noticias
            </a>
            <a href="/admin/news/create" className={linkClass('/admin/news/create')} onClick={closeNav}>
              Subir Noticia
            </a>
            <a href="/admin/categories/create" className={linkClass('/admin/categories/create')} onClick={closeNav}>
              Categorías
            </a>
            <a href="/admin/authors" className={linkClass('/admin/authors')} onClick={closeNav}>
              Autores
            </a>
            <a href="/admin/images" className={linkClass('/admin/images')} onClick={closeNav}>
              Imágenes
            </a>
            <a href="/admin/tags" className={linkClass('/admin/tags')} onClick={closeNav}>
              Tags
            </a>
            <button className="an-link an-logout" onClick={handleLogout}>
              Cerrar Sesión
            </button>
          </div>

          <span className="an-handle">@ZONAMICROONDAS</span>
        </div>

        {navOpen && (
          <div className="an-overlay" onClick={closeNav} aria-hidden="true" />
        )}
      </nav>
    </div>
  );
}
